import React, { useState } from 'react';

import { SidePage, Select, SearchInput, Grid } from '@gogame/components';
import {
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Typography,
} from '@gogame/components';
import { ScreenLink } from '@gogame/screens';

import { eventsLink } from 'scenes/Events/navigation';
import {
  SEARCH_QUERY,
  FILTERS,
  FILTER_APPLICATIONS,
} from 'scenes/Events/constants';
import { APP_ID } from 'scenes/PlayersActivities/PlayersInformation/constants';

import { useLoadApplications } from '../../data/useLoadApplications';
import { useLoadEvents } from '../../data/useLoadEvents';

const EventNames = ({ onClose, onExited, open }) => {
  const [application, setApplication] = useState(null);
  const [searchValue, setSearchValue] = useState('');

  const { data: eventsData, isLoading: isEventsLoading } = useLoadEvents(
    { [APP_ID]: application },
    {
      enabled: !!application,
    }
  );
  const { data, isLoading, isFetching } = useLoadApplications();
  const handleChange = (_e, value) => {
    setApplication(value);
  };

  const searchedEventsData = React.useMemo(() => {
    const queryKey = searchValue.toUpperCase();
    return eventsData && searchValue.length
      ? eventsData.filter(
          ({ statsEventId, name }) =>
            `${statsEventId}`.toUpperCase().includes(queryKey) ||
            `${name}`.toUpperCase().includes(queryKey)
        )
      : eventsData;
  }, [eventsData, searchValue]);

  return (
    <SidePage
      onClose={onClose}
      onExited={onExited}
      loading={isLoading}
      fetching={isFetching || isEventsLoading}
      open={open}
      size={'md'}
    >
      <SidePage.Title title={'Event Names'} />

      <SidePage.NewBody scroll={false}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Select
              value={application}
              width={276}
              options={data}
              onChange={handleChange}
              placeholder={'Application'}
            />
          </Grid>
          {eventsData?.length ? (
            <React.Fragment>
              <Grid item xs={12}>
                <SearchInput
                  placeholder={'Search'}
                  value={searchValue}
                  variant={'filled'}
                  onChange={(_e, value) => setSearchValue(value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                {searchedEventsData?.length ? (
                  <TableContainer>
                    <Table width={'100%'}>
                      <TableHead>
                        <TableRow>
                          <TableCell width={'145px'}>ID</TableCell>
                          <TableCell>Name</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {searchedEventsData?.map((event) => (
                          <TableRow key={event.id}>
                            <TableCell width={'145px'}>{event.id}</TableCell>
                            <TableCell>
                              {event.id ? (
                                <ScreenLink
                                  target={'_blank'}
                                  link={eventsLink}
                                  params={{
                                    [SEARCH_QUERY]: event.name,
                                    [FILTERS]: {
                                      [FILTER_APPLICATIONS]: [application],
                                    },
                                  }}
                                >
                                  {event.name}
                                </ScreenLink>
                              ) : (
                                event.name
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : !isFetching && !isLoading && application ? (
                  <Typography>No events</Typography>
                ) : null}
              </Grid>
            </React.Fragment>
          ) : null}
        </Grid>
      </SidePage.NewBody>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
    </SidePage>
  );
};

export default EventNames;
